export const ONE_DAY_IN_SECONDS = 86400;
